import { Center } from '@chakra-ui/react';
import React from 'react';
import SvgIconMemberCare from '../SvgIconMemberCare';

const MemberCareCircledIcon = ({ size = 60 }: { size?: number }) => {
  return (
    <Center
      width={`${size}px`}
      height={`${size}px`}
      backgroundColor={'primary.500'}
      padding={'8px'}
      rounded={'full'}
      boxShadow="0px 10px 20px 2px #00417926"
    >
      <SvgIconMemberCare width={size / 2.6} />
    </Center>
  );
};

export default MemberCareCircledIcon;
